import React from "react";

import theme from "../../utils/theme";

import { styled } from "@mui/material/styles";

import TextField, { TextFieldProps } from "@mui/material/TextField";
import FieldTitle from "../FieldTitle";
import { InputContainer } from "./styles";
import ErrorMessage from "../ErrorMessage";
const { colors } = theme;

interface InputProps {
	value?: string | number | null;
	renderValue?: (value: any) => any;
	placeholder?: string;
	onChange?: React.ChangeEventHandler<HTMLInputElement>;
	type?: React.HTMLInputTypeAttribute;
	form?: string;
	label?: string;
	inputContainerStyle?: string;
	className?: string;
	valueType?: string;
	required?: boolean;
	error?: string;
	disabled?: boolean;
	id?: string;
	datatestid?: string;
	fieldTitleClassName?: string;
	showValue?: boolean;
	textFieldClassName?: string;
	onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
	inputIconRight?: React.ReactNode;
}

const CssTextField = styled((props: TextFieldProps) => <TextField {...props} />)(({ theme }) => ({
	"& .MuiInput-underline:after": {
		borderBottomColor: colors.primary,
	},
	"& .MuiOutlinedInput-root": {
		"&:hover fieldset": {
			borderColor: colors.primary,
		},
		"&.Mui-focused fieldset": {
			borderColor: colors.primary,
		},
	},
}));

const onlyAllowNumbers: React.KeyboardEventHandler<HTMLInputElement> = (e) => {
	const allowedKeys = [
		"Backspace",
		"Tab",
		"ArrowLeft",
		"ArrowRight",
		"Delete",
		".", // si querés permitir decimales
	];

	if (
		!allowedKeys.includes(e.key) &&
		!/^[0-9]$/.test(e.key) // solo permite números
	) {
		e.preventDefault();
	}
};

const BasicInput = ({
	value = "",
	renderValue,
	placeholder = "",
	onChange = () => null,
	type,
	form,
	label,
	inputContainerStyle = "",
	className = "",
	valueType = "",
	required = false,
	error,
	id = "outlined-basic",
	disabled = false,
	datatestid = "",
	showValue,
	fieldTitleClassName = "",
	textFieldClassName = "",
	onKeyDown = () => {},
	inputIconRight,
}: InputProps) => {
	let min = 1;
	let max = 100;
	if (valueType === "CP") {
		min = 4;
		max = 4;
	}

	if (showValue && !!!value) {
		return null;
	}

	return (
		<div className={className}>
			{label && <FieldTitle label={label + (required ? "*" : "")} className={fieldTitleClassName} />}
			{showValue ? (
				<div>{renderValue ? renderValue(value) : value}</div>
			) : (
				<InputContainer $extraStyle={inputContainerStyle} className="mb-0">
					<CssTextField
						key={id}
						label={""}
						className={textFieldClassName}
						variant="outlined"
						onChange={onChange}
						placeholder={placeholder}
						inputProps={{
							form,
							value: value ?? "",
							max,
							min,
							step: 0.01,
							style: { height: "1.2rem", fontSize: "0.9rem" },
							"data-testid": datatestid,
							className: type === "number" ? "hide-spinner" : "",
							onKeyDown,
						}}
						error={!!error}
						type={type}
						disabled={disabled}
						size="small"
						required={required}
						lang="es"
						onKeyDown={type === "number" ? onlyAllowNumbers : undefined}
					/>

					{inputIconRight && (
						<div
							style={{
								top: 2,
								right: 5,
							}}
							className="position-absolute"
						>
							{inputIconRight}
						</div>
					)}
				</InputContainer>
			)}
			{error && <ErrorMessage error={error} />}
		</div>
	);
};

export default BasicInput;
